const getJourneyDepartureDate = ({ legs }) => legs.length > 0 ? legs[0].localDepartAt : void 0;
var getJourneyDepartureDate_default = getJourneyDepartureDate;
export {
  getJourneyDepartureDate_default as default
};
